import {
    Box,
    Button,
    FormControl,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
  } from "@mui/material";
  import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
  import AddCircleIcon from "@mui/icons-material/AddCircle";
  import React, { useEffect, useRef, useState } from "react";
  import Grid from "@mui/material/Grid";
  import SelectComponent from "../../components/SelectComponent/SelectComponent";
  import Addguest from "./Addguest";
  import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
  import lang from "../../assets/lang.png";
  import DateComponent from "./DateComponent";
  import ReservationType from "./ReservationType";
  import TimeComponent from "./TimeComponent";
  import ReservationGroup from "./ReservationGroup";
  import { useDispatch, useSelector } from "react-redux";
  import {
    checkGuestLimit,
    setDateLoading,
    setFreeTablesData,
    setGuestCount,
    setIsBackToHoreca,
    setLanguageID,
    setLanguageWords,
    setReservationGroupDatas,
    setReservationTypeDatas,
    updateDefaultLanguage,
    updateReservationGroup,
    updateReservationType,
    updateSelectedDate,
    updateTime,
    updateTotalCount,
  } from "../../store/slice/Addguest.slice";
  import BookNowForm from "./BooknowForm";
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  import CloseIcon from "@mui/icons-material/Close";
  import {
    FetchWidgetConfigDetails,
    GetGuestDetailsByKey,
    getCalenderDatas,
    getLanguageDetails,
    getReservationGroup,
    getReservationType,
    getReservationTypeBasedOnProducts,
    getWidgetSettings,
    getWidgetTitleandInfo,
  } from "../../api/HorecaWidget.service";
  import CheckBoxIcon from "@mui/icons-material/CheckBox";
  import {
    setLanguageLoaded,
    updateBlockedDates,
    updateButtonText,
    updateGuestInfo,
    updateLanguageData,
    updateWidgetConfig,
    updateWidgetSetting,
  } from "../../store/slice/widgetSetting.slice";
  import customParseFormat from "dayjs/plugin/customParseFormat";
  import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
  import dayjs from "dayjs";
  import { setCombinationList } from "../../store/slice/Activity.slice";
  import { getCombinationList } from "../../api/activity.service";
import useHorecaWidget from "../../hooks/useHorecaWidget";
  dayjs?.extend(customParseFormat); // Extend for custom date format parsing
  

const Widget = ({handleClose}) => {
  const theme = useTheme();
  const{combinationLoading}=useHorecaWidget()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const {
    totalCount,
    selectedDate,
    reservType,
    time,
    reservGroup,
    adult,
    child,
    kid,
    baby,
    toddler,
    reservationGroupData,
    dateLoading,
    isBackToHoreca,
    defaultLanguage,
    selectedExtraProduct,
    languageWords,
    languageId,
    isOpenWidget,
    isGreaterThan10,
    freeTablesData,
    reservationTypeDatas,
  } = useSelector((store) => store.addGuest);
  const {
    key,
    widgetConfig,
    languageData,
    blockedDates,
    resType,
    widgetSetupId
  } = useSelector((store) => store?.widgetSettings);
  const location = useLocation();
  const navigate = useNavigate();
  const { isBookNowOpen } = useSelector((store) => store.addGuest);
  const dispatch = useDispatch();
  const [reservTypeLoading, setReserveTypeLoading] = useState(false);
  const [reservationRequestMin, setResReqMin] = useState(0);
  const [isAddGuest, setIsAddGuest] = useState(false);
  const dateRef = useRef(null);
  const guestRef = useRef(null);
  const reservationType = useRef(null);
  const timeRef = useRef(null);
  const reservationGroupRef = useRef(null);
  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
  const [isReservationType, setIsReservationType] = useState(false);
  const [isTimeComponent, setIsTimeComponent] = useState(false);
  const [isGrouptype, setIsTypeGroup] = useState(false);
  const [openWidget, setOpenWidget] = useState(
    location?.state?.openWidgetScreen ?? isOpenWidget
  );

  const handleLanguageChange = (event) => {
    const selectedLangCode = event.target.value;
    const selectedLanguage = languageData?.find(
      (item) => item.langcode === selectedLangCode
    );
    dispatch(setIsBackToHoreca(false));
    dispatch(updateDefaultLanguage(selectedLanguage?.langcode));
    dispatch(setLanguageID(selectedLanguage?.idlanguage));
    localStorage.setItem(
      "widget",
      JSON.stringify({
        id: widgetSetupId,
        key: key,
        lang: selectedLanguage?.langcode,
        resType:resType
      })
    );
  };
  const nonEmptyFields = Object.keys(widgetConfig?.fields || {}) // Use the correct object
    .filter(
      (key) =>
        key.startsWith("field") && widgetConfig?.fields[key]?.trim() !== "" // Check if it exists and is not empty
    )
    .map((key) => widgetConfig.fields[key]);
    const resetReservationData = () => {
        dispatch(setIsBackToHoreca(false));
        if (blockedDates?.length > 0) dispatch(updateBlockedDates([]));
        if (reservationTypeDatas?.length > 0) dispatch(setReservationTypeDatas([]));
        if (reservationGroupData?.length > 0)
          dispatch(setReservationGroupDatas([]));
        if (freeTablesData?.length > 0) dispatch(setFreeTablesData([]));
        if (Object?.keys(reservType)?.length > 0)
          dispatch(updateReservationType({}));
        if (selectedDate?.trim() !== "") dispatch(updateSelectedDate(""));
        if (time?.trim() !== "") dispatch(updateTime(""));
        if (reservGroup && Object?.keys(reservGroup)?.length > 0)
          dispatch(updateReservationGroup({}));
      };
  return (
    <Box
      className="test"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: isSmallScreen ? "flex-start" : "flex-end",
        position: "absolute",
        width: "100%",
        // bottom: "0px",
        //   paddingBottom: "20px",
        backgroundColor: theme.widget?.mainBg,

        height: isSmallScreen || isMediumScreen ? "100%" : "auto",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1567px",
          padding: { xs: 2, sm: 3 },
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                color: theme?.widget?.titleTextClr,
              }}
            >
              {languageWords?.widgetHeading || "Make your Reservations"}
            </Typography>
          </Box>

          {languageData?.length > 1 && (
            <Box
              sx={{
                display: "flex",
                gap: "1rem",
                //    mr: isSmallScreen || isMediumScreen ? "1rem" : "12rem",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                sx={{
                  minWidth: 120,
                  backgroundColor: theme?.widget?.langBgColor,
                  width: { xs: "100px", md: "120px" },
                  height: "45px",
                  borderRadius: "5px",
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                }}
              >
                <Select
                  value={defaultLanguage}
                  onChange={handleLanguageChange} // Set the onChange handler here
                  // IconComponent={() => (
                  //     <KeyboardArrowDownIcon
                  //         sx={{ color: "black", mr: 1 }}
                  //     />
                  // )}
                  displayEmpty
                  renderValue={() => (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={lang}
                        alt={"lang-img"}
                        style={{ width: "40px", marginRight: "10px" }}
                      />
                    </Box>
                  )}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      //     color: "#9F9F9F",
                      fontSize: "12px",
                    },
                  }}
                >
                  {languageData?.map((item, index) => (
                    <MenuItem
                      key={item?.idlanguage}
                      value={item?.langcode}
                      sx={{
                        color: theme?.palette?.widget?.langTextColor, // Text color of MenuItem
                        "&.Mui-selected": {
                          backgroundColor: theme?.widget?.langActiveBgColor, // Highlight selected item
                        },
                        "&:hover": {
                          backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                          color: theme?.widget?.langTextHover,
                          "&.Mui-selected": {
                            backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                            color: theme?.widget?.langTextHover,
                          },
                        },
                      }}
                    >
                      {(item?.langcode == defaultLanguage?.trim()) != "" ? (
                        <>
                          {item?.language}
                          <CheckBoxIcon
                            sx={{
                              color: theme?.widget?.langCheckboxActive,
                              marginRight: "8px",
                              ml: 2,
                            }}
                          />
                        </>
                      ) : (
                        item?.language
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {widgetConfig?.settings?.floatButtonActive && (
                <IconButton
                  aria-label="closeIcon"
                  size="large"
                  onClick={() => handleClose()}
                  sx={{
                    backgroundColor: theme?.widgetButton?.closeBg,

                    "&:hover": {
                      backgroundColor: theme?.widgetButton?.closeHover,
                    },
                  }}
                >
                  <CloseIcon
                    sx={{
                      color: theme?.widgetButton?.closeText,
                      "&:hover": {
                        color: theme?.widgetButton?.textcloseTextHover,
                      },
                    }}
                  />
                </IconButton>
              )}
            </Box>
          )}
        </Box>
        {totalCount >= widgetConfig?.reservationRequestMin && (
          <Box
            sx={{
              textAlign: "left",
              textWrap: "wrap",
              color: theme?.widget?.reservGrpTextClr,
              mb: 1,
            }}
          >
            {languageWords?.reservationGroupText}
          </Box>
        )}

        <Grid container spacing={2} sx={{ mb: 3 }}>
          {nonEmptyFields.length <= 1 ? (
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <FormControl
                fullWidth
                sx={{
                  width: "100%",
                  height: "70px",
                  px: 1,
                  position: "relative",
                  backgroundColor: theme?.guest?.bgColor,
                  // Remove border from the outlined input
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },

                  // Ensure the input itself doesn't have a border
                  "& .MuiInputBase-root": {
                    border: "none",
                    boxShadow: "none",
                  },

                  // Remove border on focus
                  "& .Mui-focused": {
                    border: "none",
                    boxShadow: "none",
                  },
                }}
              >
                {isGreaterThan10?.adult ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: "0.1rem", sm: "0.2rem" },
                    }}
                  >
                    <IconButton
                      aria-label="add-icon"
                      sx={{
                        color: theme?.guest?.textColor,
                        position: "absolute",
                        left: "3rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 2,
                      }}
                      onClick={(event) => {
                        event.stopPropagation(); // Prevent TextField click
                        if (adult > 1) {
                          resetReservationData();
                          dispatch(
                            setGuestCount({
                              guestType: "adult",
                              count: adult - 1,
                            })
                          );
                        }
                      }}
                    >
                      <RemoveCircleIcon />
                    </IconButton>
                    <Typography
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 20,
                        fontSize: "12px",
                        color: theme?.widget?.inputTextColor,
                        fontWeight: 200,
                      }}
                    >
                      {languageWords?.Guest}
                    </Typography>
                    <TextField
                      sx={{
                        position: "relative",
                        height: "30px",
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: theme?.guest?.dropdownBorderColor,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: theme?.guest?.dropdownBorderColor,
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          textAlign: "center",
                          py: 3,
                          color: "#9F9F9F",
                          border: "none",
                        },
                      }}
                      placeholder="00"
                      name="adult"
                      value={adult}
                      disabled={true}
                    />
                    <IconButton
                      aria-label="add-icon"
                      sx={{
                        color: theme?.guest?.textColor,
                        position: "absolute",
                        right: "3rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 2,
                      }}
                      onClick={() => {
                        resetReservationData();
                        dispatch(
                          setGuestCount({
                            guestType: "adult",
                            count: adult + 1,
                          })
                        );
                      }}
                    >
                      <AddCircleIcon />
                    </IconButton>
                  </Box>
                ) : (
                  <Box>
                    <Typography
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 20,
                        fontSize: "12px",
                        color: theme?.widget?.inputTextColor,
                        fontWeight: 200,
                      }}
                    >
                      {languageWords?.Guest}
                    </Typography>
                    <KeyboardArrowDownIcon
                      sx={{
                        position: "absolute",
                        top: 20,
                        right: 20,
                      }}
                    />

                    <Select
                      id="demo-simple-select"
                      value={adult}
                      fullWidth
                      // IconComponent={KeyboardArrowDownIcon}
                      IconComponent={null} // Remove the default arrow icon
                      sx={{
                        position: "relative",

                        width: "100%",
                        height: "72px",
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          color: theme?.guest?.textColor,
                          ml: 3,
                          mt: 1,
                          fontSize: { sm: "12px", md: "14px" },
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Remove default border
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none !important", // Ensure no border on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Ensure no border on focus
                        },
                      }}
                      onChange={(event) => {
                        resetReservationData();
                        dispatch(
                          setGuestCount({
                            guestType: "adult",
                            count: Number(event.target.value),
                          })
                        );
                      }}
                    >
                      {new Array(10).fill(null).map((_, index) => (
                        <MenuItem
                          key={index}
                          value={index + 1}
                          sx={{
                            color: theme?.guest?.dropdownTextColor,
                            width: "100%",
                            fontSize: { sm: "12px", md: "1.2rem" },
                            "&:hover": {
                              backgroundColor: theme?.guest?.dropdownBgHover,
                              color: theme?.guest?.dropdownTextColorHover,
                            },
                          }}
                        >
                          {index + 1}
                        </MenuItem>
                      ))}
                      <MenuItem
                        value={11}
                        sx={{
                          color: theme?.guest?.dropdownTextColor,
                          fontSize: { sm: "12px" },
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          dispatch(
                            checkGuestLimit({
                              guestType: "adult",
                              isGreaterThan10: true,
                            })
                          );
                          dispatch(
                            setGuestCount({
                              guestType: "adult",
                              count: 11,
                            })
                          );
                        }}
                      >
                        <AddBoxTwoToneIcon
                          sx={{
                            color: theme?.guest?.plusColor,
                            width: { xs: 16, sm: 20 },
                            height: { xs: 16, sm: 20 },
                            "&:hover": {
                              color: theme?.guest?.plusHover,
                            },
                          }}
                        />
                      </MenuItem>
                    </Select>
                  </Box>
                )}
              </FormControl>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <SelectComponent
                label={languageWords?.Guest}
                value={totalCount}
                onClick={() => {
                  setIsAddGuest(!isAddGuest);
                }}
                ref={guestRef}
                sx={{
                  position: "relative",
                  width: "100%",
                  height: "72px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: 1,
                    color: theme?.guest?.textColor,
                    ml: 3,
                    mt: 1,
                    fontSize: { sm: "12px", md: "14px" },
                  },
                }}
              />

              <Addguest
                isOpen={isAddGuest}
                handleClose={() => setIsAddGuest(false)}
                Ref={guestRef.current}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <SelectComponent
              label={languageWords?.date}
              value={selectedDate?.trim() != "" ? selectedDate : "DD-MM-YYYY"}
              onClick={() => setIsDateDropdownOpen(!isDateDropdownOpen)}
              ref={dateRef}
              disabled={totalCount > 0 ? false : true}
              sx={{
                position: "relative",

                width: "100%",
                height: "72px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: 1,
                  color: theme?.guest?.textColor,
                  ml: 3,
                  mt: 1,
                  fontSize: { sm: "12px", md: "14px" },
                },
              }}
            />
            <DateComponent
              isOpen={isDateDropdownOpen}
              handleClose={() => setIsDateDropdownOpen(false)}
              Ref={dateRef.current}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <SelectComponent
              label={languageWords?.reserveType}
              value={
                reservType &&
                typeof reservType === "object" &&
                Object.keys(reservType).length > 0
                  ? reservType?.name
                  : "Type"
              }
              onClick={() => {
                // setAnchorPosition(reservationType);
                setIsReservationType(!isReservationType);
              }}
              ref={reservationType}
              disabled={selectedDate?.trim() != "" ? false : true}
              sx={{
                position: "relative",

                width: "100%",
                height: "72px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: 1,
                  color: theme?.guest?.textColor,
                  ml: 3,
                  mt: 1,
                  fontSize: { sm: "12px", md: "14px" },
                },
              }}
            />
            <ReservationType
              isOpen={isReservationType}
              handleClose={() => setIsReservationType(false)}
              Ref={reservationType.current}
              isLoading={reservTypeLoading}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <SelectComponent
              label={languageWords?.Time}
              value={time?.trim() != "" ? time?.substring(0, 5) : "HH:MM"}
              onClick={() => setIsTimeComponent(!isTimeComponent)}
              ref={timeRef}
              disabled={
                reservType &&
                typeof reservType === "object" &&
                Object.keys(reservType).length > 0
                  ? false
                  : true
              }
              sx={{
                position: "relative",

                width: "100%",
                height: "72px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: 1,
                  color: theme?.guest?.textColor,
                  ml: 3,
                  mt: 1,
                  fontSize: { sm: "12px", md: "14px" },
                },
              }}
            />
            <TimeComponent
              isOpen={isTimeComponent}
              handleClose={() => setIsTimeComponent(false)}
              Ref={timeRef.current}
            />
          </Grid>

          {widgetConfig?.settings?.showReservationGroup && (
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <SelectComponent
                label={languageWords?.reserveGroup}
                value={
                  reservGroup &&
                  typeof reservGroup === "object" &&
                  Object.keys(reservGroup).length > 0
                    ? reservGroup?.name
                    : "Group"
                }
                onClick={() => setIsTypeGroup(!isGrouptype)}
                ref={reservationGroupRef}
                disabled={time?.trim() != "" ? false : true}
                sx={{
                  position: "relative",

                  width: "100%",
                  height: "72px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: 1,
                    color: theme?.guest?.textColor,
                    ml: 3,
                    mt: 1,
                    fontSize: { sm: "12px", md: "14px" },
                  },
                }}
              />
              <ReservationGroup
                isOpen={isGrouptype}
                handleClose={() => setIsTypeGroup(false)}
                Ref={reservationGroupRef.current}
                disabled={
                  reservGroup &&
                  typeof reservGroup === "object" &&
                  Object.keys(reservGroup).length > 0
                    ? false
                    : true
                }
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                height: "70px",
                backgroundColor:
                  reservType &&
                  typeof reservType === "object" &&
                  Object.keys(reservType).length > 0 &&
                  totalCount > 0 &&
                  selectedDate?.trim() != "" &&
                  time?.trim() != ""
                    ? theme?.widget?.bookNowbtnBgActive
                    : theme?.widget?.bookNowBtnBg,
                color:
                  reservType &&
                  typeof reservType === "object" &&
                  Object.keys(reservType).length > 0 &&
                  totalCount > 0 &&
                  selectedDate?.trim() != "" &&
                  time?.trim() != ""
                    ? theme?.widget?.booknowBtnTextColorActive
                    : theme?.widget?.booknowBtnTextColor,
                fontWeight: "bold",
                display: "flex", // Ensure flexbox is used
                flexDirection: "column", // Align content in a column (Book Now on top, €25,00 below)
                justifyContent: "center", // Center the text vertically
                alignItems: "center", // Center the text horizontally
              }}
              onClick={() => {
                if (
                  reservType &&
                  typeof reservType === "object" &&
                  Object.keys(reservType).length > 0 &&
                  totalCount > 0 &&
                  selectedDate?.trim() != "" &&
                  time?.trim() != "" && !combinationLoading
                ) {
                  navigate(`/bookNow`);
                } else {
                  return;
                }
              }}
              disabled={combinationLoading}
            >
              {languageWords?.Booknow}
              {reservType?.totalCost > 0 &&
                totalCount < widgetConfig?.reservationRequestMin && (
                  <Box component="span" fontSize="13px" fontWeight="200">
                    €{parseFloat(reservType?.totalCost).toFixed(2)}
                  </Box>
                )}
            </Button>
          </Grid>
        </Grid>

        {isBookNowOpen && <BookNowForm />}
      </Box>
    </Box>
  );
};

export default Widget;
